define([
    "jquery",
    "underscore",
    "marionette",
    "views/payout/common_view",
    "forms/payout/bankwire_sticpay_form"
], function($, _, Marionette, CommonView, BankwireSticpayForm) {
    return CommonView.extend({
        ui: _.extend(CommonView.prototype.ui, {
            'signature': '#signature',
            'signatureName': '#signature_name',
            'bankInfo': '#bank_info',
            'bankName': '#bank_name',
            'bankAccount': '#bank_account',
            'swiftCode': '#swift_code',
            'bankAccountHolder': '#bank_account_holder',
            'bankAddress': '#bank_address',
            'bankCode': '#bank_code',
            'bankCountry': '#bank_country',
        }),

        events: _.extend(CommonView.prototype.events, {
            'change @ui.bankCode': 'updateBankName',
            'change @ui.bankCountry': 'updateBankCountry'
        }),

        initialize: function(){
            this.bindUIElements();
            this.delegateEvents();
            this.form = new BankwireSticpayForm();

            if(this.ui.bankCode.val() !== undefined){
                this.updateBankName()
            }
        },

        updateBankName:function(){
            this.ui.bankName.val($("#bank_code option:selected").html());
        },

        updateBankCountry:function(){
            window.location.replace("/payout/bankwire?bank_country=" + this.ui.bankCountry.val());
        }
    });
});
